// NPM Imports
import React, { Component } from "react";
import Tooltip from "rc-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Internal Imports
import { DRAFT } from "../../constants";
import { checkAlignTypeBtnStatus } from "../../utils/draftUtils";

// Destructuring
const { TOOLBAR_LINE_HEIGHT_UNITS } = DRAFT;

class LineHeight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLineHeight: "1.6",
    };
  }

  componentDidMount = () => {
    TOOLBAR_LINE_HEIGHT_UNITS.forEach(lineHeight => {
      const { isActive } = checkAlignTypeBtnStatus(
        this.props.editorState,
        lineHeight.style,
      );
      if (isActive) this.setState({ currentLineHeight: lineHeight.value });
    });
    document.addEventListener("mousedown", this._handleClick, false);
  };

  componentDidUpdate = prevProps => {
    if (
      prevProps.editorState.getSelection().isCollapsed() &&
      !this.props.editorState.getSelection().isCollapsed()
    ) {
      const { stylesArr: appliedLineHeight, isLineHeightPresent } =
        this._checkMultipleLineHeights();
      if (
        (appliedLineHeight.length > 1 ||
          (appliedLineHeight.length === 0 && isLineHeightPresent)) &&
        this.state.currentLineHeight !== null
      ) {
        this.setState({ currentLineHeight: null });
      }
    } else
      TOOLBAR_LINE_HEIGHT_UNITS.forEach(lineHeight => {
        const isActive = checkAlignTypeBtnStatus(
          this.props.editorState,
          lineHeight.style,
        );
        if (isActive && this.state.currentLineHeight !== lineHeight.value)
          this.setState({ currentLineHeight: lineHeight.value });
      });
  };

  componentWillUnmount = () => {
    document.removeEventListener("mousedown", this._handleClick, false);
  };

  _checkMultipleLineHeights = () => {
    const { editorState } = this.props;
    const contentState = editorState.getCurrentContent();
    const selectionState = editorState.getSelection();
    let startBlockKey = selectionState.getStartKey();
    const endBlockKey = contentState.getKeyAfter(selectionState.getEndKey());
    const appliedLineHeight = [];
    const lineHeightOptions = [
      "line-height:0.5",
      "line-height:1",
      "line-height:1.15",
      "line-height:1.5",
      "line-height:2",
    ];
    let isLineHeightPresent = false;
    while (startBlockKey !== endBlockKey) {
      const currentBlock = contentState.getBlockForKey(startBlockKey);
      if (currentBlock && currentBlock.getData()) {
        const getStyle = currentBlock.getData().get("elementStyle");
        if (getStyle) {
          if (getStyle.includes("line-height")) isLineHeightPresent = true;
          const styleArr = getStyle.split(";");
          const filteredArray = lineHeightOptions.filter(value =>
            styleArr.includes(value),
          );
          if (filteredArray.length > 0) {
            appliedLineHeight.push(...filteredArray);
          }
        }
        startBlockKey = contentState.getKeyAfter(startBlockKey);
      }
    }
    return { stylesArr: [...new Set(appliedLineHeight)], isLineHeightPresent };
  };

  _onChange = (event, lineHeightValue) => {
    event.preventDefault();
    this.props.handleLineHeight("LineHeight", lineHeightValue);
    if (this.props.activeToolbarDropDown) {
      this.props.toogleToolbarDropDown(null);
    }
  };

  _toggleDropdown = event => {
    event.preventDefault();
    this.props.toogleToolbarDropDown(
      this.props.activeToolbarDropDown === "LINE_HEIGHT" ? null : "LINE_HEIGHT",
    );
  };

  render() {
    return (
      <div
        className="draft-edit-items"
        ref={ele => {
          this.node = ele;
        }}>
        <div className="draftJsToolbar__buttonWrapper__1Dmqh">
          <Tooltip
            placement="top"
            overlay="Line Height"
            align={{
              offset: [3, 0],
            }}>
            <button
              data-test="toolbar-line-height-dropdown-button"
              type="button"
              className="draftJsToolbar__button__qi1gf"
              onMouseDown={this._toggleDropdown}>
              <i className="ic-dropdown">
                <FontAwesomeIcon
                  icon={["fas", "line-height"]}
                  className="breadcrumb-bredcrumb-icon"
                />
              </i>
            </button>
          </Tooltip>
        </div>
        {/* ------- Header dropdown list section ------ */}
        {this.props.activeToolbarDropDown === "LINE_HEIGHT" && (
          <div className="customsize-style-wrapper">
            <div className="customsize-style-fontoptions-wrapper">
              <ul className="customsize-style-fontoptions show-scrollbar">
                {TOOLBAR_LINE_HEIGHT_UNITS.map(lineHeight => {
                  let className =
                    "customsize-style-fontoption line-height-option";
                  if (this.state.currentLineHeight === lineHeight.value) {
                    className += " active";
                  }
                  return (
                    <li
                      key={lineHeight.id}
                      // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                      role="button"
                      tabIndex={0}
                      onMouseDown={e => this._onChange(e, lineHeight.value)}>
                      <div className={className}>{lineHeight.toolBarValue}</div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default LineHeight;
